/**
 * @generated SignedSource<<2a797f95d565e272b64c867b7e10016a>>
 * @relayHash 3ad9de847a73c165c119877312ac8b41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7e949716a36a3b7276a3e0c3e396a35d07392bc693f41443586e94aec2d3222b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4AppsContentViewQuery$variables = {
  cloudId: string;
};
export type Nav4AppsContentViewQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"Nav4AppsContent">;
  };
};
export type Nav4AppsContentViewQuery = {
  response: Nav4AppsContentViewQuery$data;
  variables: Nav4AppsContentViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "label"
},
v2 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v3 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "Nav4AppsContentViewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "Nav4AppsContent"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Nav4AppsContentViewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "JiraNavigationItemConnection",
            "kind": "LinkedField",
            "name": "globalAppNavigationItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraNavigationItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "appId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "appType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "envLabel"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "iconUrl"
                          },
                          (v2/*: any*/),
                          {
                            "concreteType": "JiraAppSection",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "concreteType": "JiraAppNavigationItemNestedLink",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": true,
                                "selections": [
                                  (v1/*: any*/),
                                  (v3/*: any*/),
                                  (v2/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "settingsUrl"
                          },
                          (v3/*: any*/)
                        ],
                        "type": "JiraAppNavigationItem"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7e949716a36a3b7276a3e0c3e396a35d07392bc693f41443586e94aec2d3222b",
    "metadata": {},
    "name": "Nav4AppsContentViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "157a8cfe104b1d671cc09c5f8aee481a";

export default node;
